import FixedHeader from './FixedHeader'
import './OverlayContent.sass'
import {Spin} from 'antd'

export default function OverlayContent({loading = false, active = false, children, onClose = undefined, classes = ""}) {
  return (

    <div className={`overlay-content-wrapper ${classes} ${active ? 'active' : ''}`}>
      <FixedHeader onClose={onClose}/>
      <Spin spinning={loading} size="large">
        <div className="overlay-content">
          {children}
        </div>
      </Spin>
      <div className="menu-spacer"></div>
    </div>
  )
}